import React from 'react';
import { DepotAddress } from '../../Models';

interface DepotAddressMapInterface {
  depotAddress: DepotAddress;
}

export const DepotAddressMap: React.FC<DepotAddressMapInterface> = ({ depotAddress }) => {
  return (
    <div className="d-flex flex-column align-items-center h-100 mt-4">
      <iframe
        src={`https://maps.google.com/maps?q=${depotAddress.city}+${depotAddress.street}+${depotAddress.houseNo}+${depotAddress.zip}&z=14&output=embed`}
        title="Depotstandort"
        className="pickup-address-map"></iframe>
    </div>
  );
};
